<template>
  <div class="Edge">  
    <div class="Edge__container">
      <div class="Edge__title">
        <img :src="require('./img/logo_' + lang + '.png')" />
        <div class="Edge__subtitle" v-html="trans('subtitle')"/>
      </div>
      <div class="Edge__middle">
        <div class="Edge__description" v-html="trans('description')"/>   
      </div>
      <div class="Edge__logos">  
        <div class="Edge__logo">
          <img class="Edge__ico" :src="require('./img/edge.png')" />
          <div class="Edge__mark">Edge</div>
        </div>
      </div>
      <div class="Edge__footer">
        <img :src="require('./img/parlement-' + lang + '.png')" /> 
        <img :src="require('./img/onf.png')" />  
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Edge',
  translations: {
    fr: {
      subtitle: "L'expérience en ligne.",
      description: "Votre version de navigateur est dépassée.<br/>Mettez à jour votre navigateur et rechargez la page.",
    },
    en: {
      subtitle: "The Online Experience.",
      description: "Your version of browser is obsolete.<br/>Update your browser and reset page.",
    }
  },
}
</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Edge
  display flex
  justify-content center
  align-items center
  position absolute 
  width 100vw
  height 100vh
  background #020221
  z-index 20000

  &__container
    display flex
    flex-direction column
    align-items center
    justify-content space-between
    height 50vh

  &__title
    font-size 30px
    display flex
    width 100%
    flex-direction column
    justify-content center
    align-items center
 
    & img
      width 398px
      height 44px

  &__subtitle
    padding 16px 0 0

  &__description
    text-align center
    line-height 28px

  &__logos
    display flex
    flex-direction row

  &__logo 
    padding 0 32px
    align-items center
    justify-content center

  &__ico 
    display flex
    flex-direction column
    width 48px
    padding-left 4px

  &__mark
    padding-top 16px
    text-align center

  &__footer
    position absolute
    left 50%
    transform translateX(-50%)
    bottom 0
    display flex
    flex-direction row
    justify-content center

    & img
      padding 24px
      width 12.5%

</style>

















